
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from '../common/services/auth.service';
import { SpinnerService } from '../shared/spinner';
import Utils, { WebViewMsg } from '../common/utils/utils';
@Component({
    selector: 'app-gec',
    template: ``,
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false
})
export class GECRoutingComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private spinner: SpinnerService,
    private router: Router) { }

  ngOnInit(): void {
    this.login();
  }

  private login() {

    this.spinner.show();

    this.route.queryParams.subscribe((qparams: Params) => {
          const passId = qparams.passId;

          // Notify flutter web view
          const flutterParams = {
            passId: passId
          };

          Utils.notifyWebView(WebViewMsg.CBSA, flutterParams);

          if (!passId) {
            this.router.navigate(['/']).then(() => {
              this.spinner.hide();
            });
          } else {

            this.authService.reLogin().subscribe(res => {
              if (res) {
                const user = this.authService.getUser();
                if (user && user.name) {
                  if (user.membershipOrPassId !== passId) {
                    this.router.navigate(['/']).then(() => {
                      this.spinner.hide();
                    });
                  } else {
                    this.router.navigate(['/dashboard']).then(() => {
                      this.spinner.hide();
                    });
                  }
                } else {
                  this.router.navigate(['/']).then(() => {
                    this.spinner.hide();
                  });
                }
              } else {
                this.router.navigate(['/']).then(() => {
                  this.spinner.hide();
                });
              }
            });
        }
    });
  }
}
